"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContestHeaderLayoutMediumLarge = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
/**
 * @copyright
 * Copyright (c) 2022 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
var SvgIcon_1 = __importDefault(require("@atg/icf-react-components/components/SvgIcon"));
var react_jss_1 = require("react-jss");
var Contexts_1 = require("../Contexts");
var Ioc_1 = require("../utilities/Ioc");
var ContestFilterSelector_1 = require("./ContestFilterSelector");
var ContestTitle_1 = require("./ContestTitle");
var Countdown_1 = require("./Countdown");
var useContestHeaderLayoutMediumLargeStyles = (0, react_jss_1.createUseStyles)(function (theme) { return ({
    headerWrapper: function (_a) {
        var breakpoint = _a.breakpoint;
        return ({
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            marginBottom: "8px",
            marginLeft: breakpoint === "large" ? 0 : "16px",
            marginRight: breakpoint === "large" ? 0 : "16px",
            marginTop: breakpoint === "large" ? 0 : "8px",
        });
    },
    countdowWrapper: function (_a) {
        var breakpoint = _a.breakpoint;
        return ({
            display: "flex",
            alignItems: "center",
            marginInlineStart: "8px",
            flexDirection: breakpoint === "large" ? "row" : "column",
        });
    },
    headerContentTopWrapper: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center",
    },
    endsInLabel: function (_a) {
        var breakpoint = _a.breakpoint;
        return ({
            margin: breakpoint === "large" ? "0 10px" : 0,
            fontSize: breakpoint === "large" ? 16 : 10,
            color: theme.colors.baseContrast050,
            display: breakpoint === "large" ? "inline-block" : "flex",
        });
    },
}); });
var ContestHeaderLayoutMediumLarge = function (props) {
    var emitTrackingEvent = props.emitTrackingEvent, onContestFilterChange = props.onContestFilterChange, contestFilter = props.contestFilter, contestInfo = props.contestInfo, initialTimeRemaining = props.initialTimeRemaining, isFallback = props.isFallback, totalItemCount = props.totalItemCount;
    var _a = __read((0, Ioc_1.useContexts)(Contexts_1.ITranslationServiceContext, Contexts_1.IThemeContext, Contexts_1.ILayoutContext, Contexts_1.IUserContext), 4), translate = _a[0].translate, theme = _a[1], layout = _a[2], user = _a[3];
    var breakpoint = layout.breakpoint;
    var classes = useContestHeaderLayoutMediumLargeStyles({ breakpoint: breakpoint });
    // Nothing to render without the contestInfo. Most likely there are no active contests
    if (!contestInfo) {
        return null;
    }
    return ((0, jsx_runtime_1.jsxs)("div", { className: classes.headerWrapper, "data-ta-locator": "contest-header", children: [(0, jsx_runtime_1.jsxs)("div", { className: classes.headerContentTopWrapper, children: [(0, jsx_runtime_1.jsx)(ContestTitle_1.ContestTitle, { children: contestInfo.displayName }), !isFallback && ((0, jsx_runtime_1.jsxs)("div", { className: classes.countdowWrapper, children: [breakpoint === "large" && (0, jsx_runtime_1.jsx)(SvgIcon_1.default, { name: "accessTime", fill: theme.colors.baseContrast050 }), (0, jsx_runtime_1.jsx)("div", { className: classes.endsInLabel, children: translate("contest.ends_in") }), (0, jsx_runtime_1.jsx)(Countdown_1.Countdown, { initialTimeRemaining: initialTimeRemaining })] }))] }), user.isAuthenticated && totalItemCount > 0 && !isFallback && ((0, jsx_runtime_1.jsx)(ContestFilterSelector_1.ContestFilterSelector, { emitTrackingEvent: emitTrackingEvent, onContestFilterChange: onContestFilterChange, contestFilter: contestFilter }))] }));
};
exports.ContestHeaderLayoutMediumLarge = ContestHeaderLayoutMediumLarge;
exports.ContestHeaderLayoutMediumLarge.displayName = "ContestHeaderLayoutMediumLarge";
//# sourceMappingURL=ContestHeaderLayout.medium-large.js.map